import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import {
  clearSelectedTenant,
  getTenantMemberships,
  saveSelectedTenant,
} from 'services/tenant/tenantMembershipService';

export const isSafeAppPath = (value) =>
  value?.startsWith('/') && !value.startsWith('//');

const isActiveMembership = (membership) =>
  !membership?.membershipStatus || membership.membershipStatus === 'ACTIVE';

export const getActiveMemberships = (memberships = []) =>
  memberships.filter(isActiveMembership);

const isInvitationPath = (value) => isSafeAppPath(value) && value.startsWith('/invitation/');

export function resolvePostLoginPath({ redirectTo = null, memberships = [] }) {
  if (isInvitationPath(redirectTo)) return redirectTo;
  const activeMemberships = getActiveMemberships(memberships);

  if (!activeMemberships.length) {
    return `${APP_ROUTE_PREFIX}/${RouteConstant.tenantSelection}?mode=manage`;
  }
  if (activeMemberships.length === 1) {
    return `${APP_ROUTE_PREFIX}/${RouteConstant.dashboard}`;
  }
  return `${APP_ROUTE_PREFIX}/${RouteConstant.tenantSelection}`;
}

// The single post-login entry point for password login, Google OIDC, and
// existing-session relogin. redirectTo is intentionally not returned directly:
// organization context must be resolved before an application route can open.
export async function resolvePostLoginDestination({ redirectTo = null, memberships } = {}) {
  const availableMemberships = memberships || await getTenantMemberships();
  const activeMemberships = getActiveMemberships(availableMemberships);

  if (isInvitationPath(redirectTo)) return redirectTo;

  if (activeMemberships.length === 1) {
    saveSelectedTenant(activeMemberships[0]);
  } else {
    clearSelectedTenant();
  }

  // Retained as an explicit input for future public confirmation flows.
  // It cannot bypass organization selection or its required context.
  return resolvePostLoginPath({ redirectTo, memberships: activeMemberships });
}
